<template>
  <div class="modals-container" :style="{'z-index':modalZindex}">
    <component
      :is="modal.component"
      v-for="(modal, index) in api.dynamicModals"
      :key="modal.id"
      v-model="modal.value"
      v-bind="modal.bind"
      v-on="modal.on"
      @_closed="slice(index)"
      @_beforeOpen="e => beforeOpen(e, modal)"
      @_opened="modal.opened"
    >
      <template v-for="(slot, key) in modal.slots" #[key] :key="key">
        <!-- eslint-disable vue/no-v-html -->
        <div v-if="isString(slot)" v-html="slot" />
        <component :is="slot.component" v-else v-bind="slot.bind" v-on="slot.on || {}" />
      </template>
    </component>
  </div>
</template>

<script>
export default {
  props: {},
  data() {
    return {
      modalZindex: 100,
    };
  },
  methods: {
    slice(index) {
      this.api.dynamicModals.splice(index, 1);
      // Đặt lại z-index mặc định
      this.modalZindex = 100;
    },
    async beforeOpen(e, modal, index) {
      e.ref.params.value = modal.params;
      if (modal.params.modalZindex) this.modalZindex = modal.params.modalZindex;
      else this.modalZindex = 100;
      
      if (!modal.value) {
        this.slice(index);
        modal.reject('show');
      }
    },
    isString(val) {
      return typeof val === 'string';
    },
  },
};
</script>

<style lang="scss" scoped>
.modals-container {
  // Modal để z-index là 100 còn Popover để z-index là 101
  position: fixed;
}
</style>